import React from 'react';

import {
  QuestionType,
  BaseQuestion,
} from '../../../features/variety-planner/types';
import YesNoQuestion from './YesNoQuestion';
import YesNeutralNoQuestion from './YesNeutralNoQuestion';
import MultipleChoiceQuestion from './MultipleChoiceQuestion';

interface QuestionProps {
  question: BaseQuestion;
  value: string | string[];
  onChange: (id: string, value: string | string[]) => void;
}

const Question: React.FC<Readonly<QuestionProps>> = ({
  question,
  value,
  onChange,
}) => {
  const handleChange = (newValue: string | string[]) => {
    onChange(question.id, newValue);
  };

  switch (question.type) {
    case QuestionType.SingleSelectYesNoQuestion:
      return (
        <YesNoQuestion
          question={question}
          value={value as string}
          onChange={handleChange}
        />
      );

    case QuestionType.SingleSelectYesNeutralNoQuestion:
      return (
        <YesNeutralNoQuestion
          question={question}
          value={value as string}
          onChange={handleChange}
        />
      );

    case QuestionType.MultipleSelect:
      return (
        <MultipleChoiceQuestion
          question={question}
          values={value as string[]}
          onChange={handleChange}
        />
      );

    default:
      return <div>Unknown question type: {question.type}</div>;
  }
};

export default Question;
